import { render } from "./TheSideMenu.vue?vue&type=template&id=fbe0e786&scoped=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=fbe0e786&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe0e786"]])

export default __exports__